import ModernSidebar from './ModernSidebar';

export default ModernSidebar;
